import React, { FC, memo } from "react";

import { Container } from "./styled";
import { ContainerProps } from "../types";

export const AttributeContainer: FC<ContainerProps> = memo(({ elementConfig, renderElement }) => {
  return <Container style={elementConfig?.style}>{renderElement({ id: "attribute" })}</Container>;
});
